import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import registerServiceWorker from './registerServiceWorker';

import Home from './screens/Home';
import Statistics from './screens/Statistics';
import Client from './screens/Client';
import ClientEmbed from './screens/ClientEmbed';
import Login from './screens/Login';
import NotFound from './screens/NotFound';
import Pay from './screens/Pay';
import Admin from './screens/Admin';

import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch
} from 'react-router-dom';
import config from "./config";
import Refund from "./screens/Refund";
import Devices from './screens/v2/Devices';
import MyposTerminals from './screens/v2/MyposTerminals';
import V2Layout from './screens/v2/Layout';
import ViewDevice from './screens/v2/ViewDevice';
import AddEditMyposTerminal from './screens/v2/AddEditMyposTerminal';
import Wristbands from './screens/v2/wristbands/Wristbands';
import AddEditWristbandCategory from './screens/v2/wristbands/AddEditWristbandCategory';
import ShowWristbandCategory from './screens/v2/wristbands/ShowWristbandCategory';
import ImportWristbandPacket from './screens/v2/wristbands/ImportWristbandPacket';
import ShowWristbandPacket from './screens/v2/wristbands/ShowWristbandPacket';
import ReconditioningWristband from './screens/v2/wristbands/ReconditioningWristband';
import OrderAndPay from './screens/OrderAndPay/OrderAndPay';
import Cart from './screens/OrderAndPay/Cart';
import OnpLayout from './screens/OrderAndPay/OnpLayout';
import TwintDirectPayment from './screens/OrderAndPay/TwintDirectPayment';
import OnpOrders from './screens/OrderAndPay/OnpOrders';
import PayrexxPayment from './screens/OrderAndPay/PayrexxPayment';


const Contactless = () => (
    <Router>
        <Switch>
            <Route exact path={config.baseUrl + "/"} component={Home}/>
            <Route exact path={config.baseUrl + "/client"} component={Home}/>
            <Route exact path={config.baseUrl + "/statistics/:bar"} component={Statistics}/>
            <Route exact path={config.baseUrl + "/statistics"} component={Statistics}/>
            <Route exact path={config.baseUrl + "/login"} component={Login}/>
            <Route exact path={config.baseUrl + "/login/:token"} component={Login}/>
            <Route exact path={config.baseUrl + "/refund"} component={Refund}/>
            <Route exact path={config.baseUrl + "/refund/:client"} component={Refund}/>
            <Route exact path={config.baseUrl + "/client:app(/app|)/:client"} component={Client}/>
            <Route exact path={config.baseUrl + "/client/:client/donation"} component={Client}/>
            <Route exact path={config.baseUrl + "/client/:client/pay"} component={Pay}/>
            <Route exact path={config.baseUrl + "/client/:client/embed/:mode"} component={ClientEmbed}/>
            <Route exact path={config.baseUrl + "/event/:event/client/:client"} component={Client}/>
            <Route exact path={config.baseUrl + "/admin"} component={Admin}/>
            <Route exact path={config.baseUrl + "/v2/admin"} component={V2Layout}/>
            <Route exact path={config.baseUrl + "/v2/admin/devices"} component={Devices} />
            <Route exact path={config.baseUrl + "/v2/admin/devices/:device_id/view"} component={ViewDevice} />
            <Route exact path={config.baseUrl + "/v2/admin/mypos_terminals"} component={MyposTerminals} />
            <Route exact path={config.baseUrl + "/v2/admin/mypos_terminals/add"} component={AddEditMyposTerminal} />
            <Route exact path={config.baseUrl + "/v2/admin/mypos_terminals/:mypos_terminal_id"} component={AddEditMyposTerminal} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands"} component={Wristbands} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/add"} component={AddEditWristbandCategory} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/:category_id"} component={AddEditWristbandCategory} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/:category_id/show"} component={ShowWristbandCategory} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/:category_id/import"} component={ImportWristbandPacket} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/:category_id/reconditioning"} component={ReconditioningWristband} />
            <Route exact path={config.baseUrl + "/v2/admin/wristbands/:category_id/show/:packet_id/show"} component={ShowWristbandPacket} />
            <Route exact path={config.baseUrl + "/404"} component={NotFound} />
            <Route exact path={config.baseUrl + "/:client"} component={Client}/>
            <Route exact path={config.baseUrl + "/:client/donation"} component={Client}/>
            <Route path={config.baseUrl + "/onp/:barId/:table_number"}>
                <OnpLayout>
                    <Switch>
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number"} component={OrderAndPay}/>
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number/cart"} component={Cart}/>
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number/orders"} component={OnpOrders}/>
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number/twint"} component={PayrexxPayment}/>
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number/card"} render={(props) => <PayrexxPayment {...props} method="card_payrexx" />} />
                        <Route exact path={config.baseUrl + "/onp/:barId/:table_number/twint_direct"} component={TwintDirectPayment}/>
                    </Switch>
                </OnpLayout>
            </Route>
            <Redirect to={config.baseUrl + "/404"} />
        </Switch>
    </Router>
)

ReactDOM.render(<Contactless />, document.getElementById('root'));
try {
    registerServiceWorker();
} catch (error) {
    console.warn('Error during service worker registration:', error.message);
}